<template>
  <div class="banner" id="banner">
    <swiper :options="swiperOption">
      <swiper-slide>
        <div class="swiper-item">
          <div class="swiper-a-body">
            <div class="swiper-a-title">互联网+解决方案</div>
            <div class="swiper-a-desc">绽放工场专注于互联网+领域的业务深入与定制开发。公司配备人专业服务团队，深入了解各行业互联网+应用开发需求，提供涵盖移动互联网化业务平台搭建、政企级移动互联网定制应用开发等综合性解决方案，全方位助力政府及企业从业务、产品的移动互联网规划建设与升级改造。</div>
            <div class="more" @click="$router.push('/solution')">
              <img src="../../../../static/images/home_button@2x.png" />
              <span>查看更多</span>
            </div>
          </div>
          <figure class="swiper-bg swiper-bg-a"></figure>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper-item">
          <figure class="swiper-bg swiper-bg-b"></figure>
        </div>
      </swiper-slide>
      <swiper-slide>
        <div class="swiper-item">
          <figure class="swiper-bg swiper-bg-c"></figure>
        </div>
      </swiper-slide>
      <!-- <div class="swiper-pagination" slot="pagination"></div> -->
      <div class="swiper-button-prev" slot="button-prev"></div>
      <div class="swiper-button-next" slot="button-next"></div>
    </swiper>
  </div>
</template>

<script>

  export default {
    name: '',
    data () {
      return {
        activeIndex: 1,
        swiperOption: {
          pagination: {
            el: '.swiper-pagination'
          },
          grabCursor: true,
          autoplay: true,
          loop: true,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          on: {
            slideChangeTransitionEnd: function () {
              console.log(this._proto_)
            }
          },
        }
      }
    },
    methods: {
      change (e) {
        console.log(e)
      }
    }
  }
</script>
<style scoped>
  .banner{
    width: 100%;
    position: relative;
    background: #000;
  }
  #banner {
    overflow: hidden;
  }
  .swiper-button-prev {
    background-image: url("../../../../static/images/home_h40px_leftarrow_nor@2x.png");
    background-size: 100% 100%;
  }
  .swiper-button-prev:hover {
    background-image: url("../../../../static/images/home_h40px_leftarrow_tap@2x.png");
  }
  .swiper-button-next {
    background-image: url("../../../../static/images/home_h40px_rightarrow_nor@2x.png");
    background-size: 100% 100%;
  }
  .swiper-button-next:hover {
    background-image: url("../../../../static/images/home_h40px_rightarrow_tap@2x.png");
  }

  .swiper-item {
    color: #ffffff;
    height: 560px;
    overflow: hidden;
    position: relative;
  }
  .swiper-a-body {
    max-width: 1200px;
    margin: 180px auto 0;
    font-size:16px;
  }
  .swiper-a-title {
    font-size: 2.3em;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(250,250,250,1);
  }
  .swiper-a-desc {
    width:717px;
    height:73px;
    font-size:1em;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:28px;
    margin-top: 30px;
  }
  .swiper-bg {
    width: 1920px;
    height: 560px;
    background-size: 1920px 560px;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    right: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: -1;
  }
  .swiper-bg-a {
    background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_h560px_banner%402x.png');
  }
  .swiper-bg-b {
    background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_h560px_banner2%402x.png');
  }
  .swiper-bg-c {
    background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_h560px_banner3%402x.png');
  }

  .more {
    width:176px;
    height:48px;
    background:rgba(255,87,78,1);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:18px;
    color:rgba(255,255,255,1);
    margin: 60px 0 0 0;
    cursor: pointer;
  }
  .more:hover {
    background:#dc170d;
  }
  .more img {
    width: 24px;
    height: 24px;
    transform: translateY(1px);
    margin-right: 8px;
  }
  
  @media (max-width: 1199px) and (min-width: 992px){
    .swiper-a-body {
      max-width: 1200px;
      margin: 180px auto 0;
    }
    .swiper-a-body {
      padding: 0 20px;
      font-size:15px;
    }
  }
  @media (max-width: 991px) and (min-width: 768px){
    .swiper-a-body {
      padding: 0 20px;
      font-size: 14px;
    }
  }
  @media screen and (max-width: 767px){
    .banner{
      padding-top: 50px;
    }
    .swiper-a-body {
      padding: 0 20px;
      font-size: 14px;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/index/banner/banner.vue